import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { chartColours } from '../../../theme/constants';
import { darken } from '@mui/system';

const GaugeChart = ({ data, chartHeight = 300 }) => {
    const ref = useRef(null);

    const colour = chartColours[0].value;
    const highlight = darken(colour, 0.3);

    const flatData = data.flatMap(item => Array(item.value).fill(item.name));

    const sum = flatData.reduce((acc, n) => acc + n, 0);
    const average = (sum / flatData.length).toFixed(1);
    const dataMax = Math.max(...flatData);

    const roundConvenient = n => {
        const power = Math.pow(10, Math.floor(Math.log10(n)));

        return Math.ceil(n / power) * power;
    };

    const max = roundConvenient(dataMax);

    const maxLabelLength = max.toString().replace('.', '').length;
    const valueFontSize = 150 / average.replace('.', '').length;
    const labelFontSize = 20 - maxLabelLength;
    const labelDistance = 25 + maxLabelLength;

    const options = {
        series: [
            {
                type: 'gauge',
                center: ['50%', '60%'],
                startAngle: 200,
                endAngle: -20,
                min: 0,
                max,
                itemStyle: {
                    color: colour
                },
                splitNumber: 10,
                progress: {
                    show: true,
                    width: 30
                },
                pointer: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        width: 30
                    }
                },
                axisTick: {
                    distance: -45,
                    splitNumber: 5,
                    lineStyle: {
                        width: 2,
                        color: '#999'
                    }
                },
                splitLine: {
                    distance: -52,
                    length: 14,
                    lineStyle: {
                        width: 3,
                        color: '#999'
                    }
                },
                axisLabel: {
                    distance: -labelDistance,
                    color: '#999',
                    precision: 0,
                    fontSize: labelFontSize
                },
                anchor: {
                    show: false
                },
                title: {
                    show: false
                },
                detail: {
                    valueAnimation: true,
                    width: '60%',
                    lineHeight: 40,
                    borderRadius: 8,
                    offsetCenter: [0, '-15%'],
                    fontSize: valueFontSize,
                    fontWeight: 'bolder',
                    color: 'inherit'
                },
                data: [
                    {
                        value: average
                    }
                ]
            },
            {
                type: 'gauge',
                center: ['50%', '60%'],
                startAngle: 200,
                endAngle: -20,
                min: 0,
                max,
                itemStyle: {
                    color: highlight
                },
                progress: {
                    show: true,
                    width: 8
                },
                pointer: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
                detail: {
                    show: false
                },
                data: [
                    {
                        value: average
                    }
                ]
            }
        ]
    };

    const height = Boolean(chartHeight >= 300) ? chartHeight : 300;

    return (
        <ReactECharts
            option={options}
            style={{ height }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default GaugeChart;
